import { POPOVER_BOTTOM_END } from "designSystem/styles/popover-positions";
import { Box, Button, Popover } from "designSystem/index";
import React, { MouseEventHandler, useState } from "react";

export default () => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick: MouseEventHandler = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = !!anchorEl;
	return (
		<Box textAlign="right">
			<Button design="primary" onClick={handleClick}>
				Open Popover
			</Button>
			<Popover
				anchorEl={anchorEl}
				onClose={handleClose}
				open={open}
				{...POPOVER_BOTTOM_END}
			>
				<Box px={3}>
					<p>The content of the Popover. Might be any HTML elements here.</p>
					<Button design="primary" onClick={handleClose}>
						Some Button
					</Button>
					<p>Click outside of popover to close, or click "Open Popover" button to toggle</p>
				</Box>
			</Popover>
		</Box>
	);
};

